import "@hotwired/turbo-rails"
import "../controllers"
import "trix"
import "@rails/actiontext"
import "trix/dist/trix.css"
import flatpickr from "flatpickr"
import "flatpickr/dist/l10n/ja.js"
import Sortable from "sortablejs"

document.addEventListener("turbo:load", () => {
  flatpickr(".datepicker", {
    locale: "ja",
    dateFormat: 'Y/m/d(D)',
    minDate: calculateMinDate(),
    maxDate: new Date().fp_incr(30),
    "disable": [
      function(date) {
        // 日を無効にする
        return (date.getDay() === 0);
      }
    ]
  });

  flatpickr(".datepicker-point", {
    locale: "ja",
    dateFormat: 'Y/m/d(D)',
    maxDate: "today"
  });
  
  // 今日の時刻に応じて minDate を計算
  function calculateMinDate() {
    const now = new Date();
    let minDate = new Date();
  
    const hour = now.getHours();
    const minute = now.getMinutes();
  
    // 10:30 までなら翌日
    if (hour < 10 || (hour === 10 && minute <= 30)) {
      minDate.setDate(minDate.getDate() + 1);
    } else {
      // 10:31 以降なら翌日＋1日（2営業日後）
      minDate.setDate(minDate.getDate() + 2);
    }
  
    // 日を飛ばす
    while (minDate.getDay() === 0) {
      minDate.setDate(minDate.getDate() + 1);
    }
  
    return minDate;
  }
});

console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')
